import { Playground } from '@playground';
import { Highlight } from "../../../../../packages/layout/src/components/highlight/highlight";
import * as React from 'react';
export default {
  Playground,
  Highlight,
  React
};